import React from 'react';
import {useSelector} from 'react-redux';

import Tooltip from "./Tooltip";
import {yamlIf} from "../../utils/visibleIf";

const label = (props) => {
    const renderHtmlFor = () => {
        let labelHtml = props.labelHtml;
        if (props.required) {
            labelHtml = labelHtml + "<sup>*</sup>";
        }
        return props.labelHtml ?
            (
                <label htmlFor={props.htmlFor} className="m-lg-0" dangerouslySetInnerHTML={{__html: labelHtml}} />
            )
                :
            (
                <label htmlFor={props.htmlFor} className="m-lg-0">{props.label}
                    {props.tooltip && <Tooltip text={props.tooltip}/>}
                    {props.required && <sup>*</sup>}
                    {props.requiredIf  && <_DynamicRequiredMark rule={props.requiredIf} /> }
                    {props.requiredIfNot  && <_DynamicRequiredMark rule={props.requiredIfNot} /> }
                </label>
            );
    }

    const renderSpan = () => {
        return props.labelHtml ?
            (
                <span className="label m-lg-0" dangerouslySetInnerHTML={{__html: props.labelHtml}} />
            ) :
            (
                <span className="label m-lg-0">{props.label}
                    {props.tooltip && <Tooltip text={props.tooltip}/>}
                    {props.required && <sup>*</sup>}
                </span>
            );
    }

    return (
        <div className={props.labelCols}>
            {props.htmlFor ? renderHtmlFor() : renderSpan()}
        </div>
    );
}

const _DynamicRequiredMark = ({rule}) => {
    const form = useSelector(state => state.form);
    if (yamlIf(form?.wizard?.values, rule)) {
        return <sup>*</sup>;
    }
    return null;
}

export default React.memo(label);